import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { SpeakerVCS } from './SpeakerVCS';
import { SpeakerSIP } from './SpeakerSIP';

interface Props extends ParticipantPresenterProps {}

export const Speaker = (props: Props) => {
    const { checkIsSIPParticipant } = useSIPParticipant();

    const { participant } = props;
    const isSIPParticipant = checkIsSIPParticipant(participant);

    if (isSIPParticipant) {
        return <SpeakerSIP {...props} />;
    }

    return <SpeakerVCS {...props} />;
};
